import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_PASSENGERS](state, data) {
    state.allPassengers = data
  },
}
